module.exports = __webpack_public_path__ + "img/5.e38c1cae.png";